import { render, staticRenderFns } from "./CustomAnnouncements.vue?vue&type=template&id=3f04960d"
import script from "./CustomAnnouncements.vue?vue&type=script&lang=js"
export * from "./CustomAnnouncements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports